import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Copy, Check } from "lucide-react";
import { subscribe } from "../lib/api";
import { toast } from "sonner";

export const EmailSignup = ({ dark = true }) => {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [copied, setCopied] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const r = await subscribe(email);
      setResult(r);
    } catch { toast.error("Please enter a valid email."); }
  };

  const copy = () => {
    navigator.clipboard.writeText(result.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className={`${dark ? "bg-charcoal" : "bg-cream text-bg"} py-24 sm:py-32 px-4 sm:px-8`} data-testid="email-signup">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cs-yellow">Early access</p>
        <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-5">
          Get 15% Off<br />Your First Order
        </h2>
        <p className={`mt-6 text-base ${dark ? "text-graytx" : "text-bg/60"} max-w-md mx-auto`}>
          First dibs on limited drops, early access before they sell out, and 15% off the moment you join.
        </p>

        <AnimatePresence mode="wait">
          {!result ? (
            <motion.form key="form" onSubmit={onSubmit}
              exit={{ opacity: 0, y: -10 }}
              className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="signup-form">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="you@email.com"
                data-testid="signup-email-input"
                className={`flex-1 bg-transparent border ${dark ? "border-line focus:border-cream" : "border-bg/20 focus:border-bg"} px-4 py-3.5 text-sm outline-none transition-colors duration-200 placeholder:text-graytx`} />
              <button type="submit" data-testid="signup-submit-btn"
                className={`${dark ? "bg-cream text-bg hover:bg-cs-yellow" : "bg-bg text-cream hover:bg-cs-blue"} font-mono text-[12px] uppercase tracking-[0.2em] px-8 py-3.5 transition-colors duration-200`}>
                Sign Up
              </button>
            </motion.form>
          ) : (
            <motion.div key="done" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
              className="mt-10 max-w-md mx-auto" data-testid="signup-result">
              <p className={`text-sm ${dark ? "text-cream" : "text-bg"}`}>{result.message}</p>
              <button onClick={copy} data-testid="signup-copy-code"
                className={`mt-5 w-full flex items-center justify-between border-2 border-dashed ${dark ? "border-cs-yellow" : "border-bg"} px-5 py-4`}>
                <span className="font-mono text-lg tracking-[0.15em]">{result.code}</span>
                {copied ? <Check size={18} className="text-cs-green" /> : <Copy size={16} className={dark ? "text-graytx" : "text-bg/50"} />}
              </button>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-widest text-graytx">Apply at checkout</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};
